import {commonActions} from '../../actions/commonActions';
import {guaranteeSetList} from '../../actions/guaranteeActions';
import {connect} from 'react-redux';
import List from '../../components/guarantee/OrderList';
import {API_FETCH} from '../../services/FetchService';
import {commonConstants} from "../../constants";


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

export const list = (value) => {
    return (dispatch, getState) => {
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('guarantee/inquiry',{params: value}).then(list => {
            if(list.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(guaranteeSetList(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.guarantee.list,
        common       : state.common,
        initialValues: state.guarantee.targetItem
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);
